import { Box } from "@material-ui/core";
import Config from "Config";
import React, { useEffect, useState } from "react";
import { Controller, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { send } from "../../SendRequest";
import { isEmpty, isNotEmpty, isObjectNotEmpty } from "../../Utils";
import CustomSchoolAutocomplete from "../CustomSchoolAutocomplete/CustomSchoolAutocomplete";
import CustomSelect from "../CustomSelect/CustomSelect";
import CustomTextField from "../CustomTextField/CustomTextField";

export default function CustomSchoolSelect({
    filterMethod,
    required = true,
    control,
    schoolNameFieldName, //the input name of school name
    SCRNFieldName, //the input name of SCRN
    treasuryCodeFieldName, //the input name of treasury code
    setValue,
    label,
    schoolCode = "SCRN",
    schoolLevel,
    financialType,
    disableDSSCode = false, // Choice for disable DSS schoolcode prefill
    filledSchoolCode = "", // User's previous input of DSS schoolCode
    formAIsEmpty = true, // User has not finished formA yet, no data for formA
    formBIsEmpty = true, // User has not finished formB yet, no data for formB
    notShowSCRN = false,
    onChange = () => {},
    displayFullOption = false,
    ...rest
}) {
    const dispatch = useDispatch();
    const [schoolList, setSchoolList] = useState([]);
    const [schoolListOptions, setSchoolListOptions] = useState([]); // save school list <object>
    const [schoolNameList, setSchoolNameList] = useState([]);
    const [schoolNameList2, setSchoolNameList2] = useState([]);

    const schoolName = useWatch({ control, name: schoolNameFieldName });
    const SCRN = useWatch({ control, name: SCRNFieldName });
    const treasuryCode = useWatch({ control, name: treasuryCodeFieldName });
    const [selectedSchool, setSelectedSchool] = useState([]);
    const [filledCode, setFilledCode] = useState(filledSchoolCode);

    const { t, i18n } = useTranslation();
    // const classes = useStyles();

    // useEffect(() => {
    //     const option = {
    //         url: `${Config.CONTENT_PATH}/clo/schoolList`,
    //     };
    //     dispatch(send("GET_SCHOOLLIST", option))
    //         .then((response) => response.json())
    //         .then((data) => {
    //             setSchoolList(data);
    //         });
    //     console.log("full school list: ", schoolList);
    // }, []);

    const haveDuplicate = (array, name) => {
        let toMap = [];
        array.map((item) => {
            if (item == name) {
                toMap.push(item);
            }
        });
        return toMap.length > 1;
    };

    useEffect(() => {
        let dataJson = {
            schoolLevel: schoolLevel || "",
            financialType: financialType || "",
        };
        const formData = new FormData();
        for (const item in dataJson) {
            formData.append(item, dataJson[item]);
        }
        console.log("formData: ", formData);
        const option = {
            // url: `${Config.CONTENT_PATH}/clo/schoolListFiltered`,
            url: `${Config.CONTENT_PATH}/clo/schoolList`,
            method: "POST",
            body: formData,
        };

        dispatch(send("GET_SCHOOLLIST", option))
            .then((response) => response.json())
            .then((data) => {
                // setSchoolList(data);
                setSchoolListOptions(data);
                setSchoolNameList(
                    data.map((e) => {
                        if (
                            i18n?.language == "en" ||
                            isEmpty(e.schl_chi_name)
                        ) {
                            return e.schl_eng_name;
                        } else {
                            return e.schl_chi_name;
                        }
                    })
                );
            });
        console.log("full school list: ", schoolList);
    }, [schoolLevel, financialType]);
    // useEffect(() => {
    //     const filtering = schoolList.filter(
    //         isFunction(filterMethod) ? filterMethod : () => true
    //     );
    //     setSchoolListOptions(filtering);
    //     setSchoolNameList(
    //         filtering.map((e) => {
    //             if (i18n?.language == "en") {
    //                 return e.schl_eng_name;
    //             } else {
    //                 return e.schl_chi_name;
    //             }
    //         })
    //     );
    // }, [schoolList, filterMethod]);

    useEffect(() => {
        if (isNotEmpty(schoolNameList)) {
            setSchoolNameList2(
                schoolNameList.map((item, index) => {
                    if (haveDuplicate(schoolNameList, item)) {
                        return item + " - " + schoolListOptions[index]?.scrn;
                    } else {
                        return item;
                    }
                })
            );
        }
    }, [schoolNameList]);

    useEffect(() => {
        // original
        // const tempSelectedSchool = schoolListOptions.find(
        //     (e) =>
        //         e.schl_eng_name == schoolName || e.schl_chi_name == schoolName
        // );
        let tempSelectedSchool;
        let sn = schoolName?.split(" - ")[1]; // check schoolName is duplicate
        if (sn) {
            tempSelectedSchool = schoolListOptions.find(
                (e) => e.scrn == schoolName.slice(-12)
            );
        } else {
            tempSelectedSchool = schoolListOptions.find(
                (e) =>
                    e.schl_eng_name == schoolName ||
                    e.schl_chi_name == schoolName
            );
        }
        // console.log(tempSelectedSchool);
        setSelectedSchool(tempSelectedSchool);
    }, [schoolName, schoolListOptions]);

    //set scrn and treasury code when selected school
    useEffect(() => {
        if (isObjectNotEmpty(selectedSchool)) {
            if (isNotEmpty(SCRNFieldName)) {
                setValue(SCRNFieldName, selectedSchool?.scrn);
            }
            if (
                isNotEmpty(treasuryCodeFieldName) &&
                //If the treasuryCode is included in this school
                !selectedSchool?.treaschlcode_list?.includes(treasuryCode)
            ) {
                setValue(
                    treasuryCodeFieldName,
                    selectedSchool?.treaschlcode_list?.[0]
                );
            }
        }
        if (isObjectNotEmpty(selectedSchool) && disableDSSCode) {
            if (selectedSchool?.schlfinance_typecd === "7") {
                // If either form A or form B is not empty, keep the input of schoolCode.
                if (!formAIsEmpty || !formBIsEmpty) {
                    setValue(treasuryCodeFieldName, filledCode);
                } else {
                    setValue(treasuryCodeFieldName, "");
                }
            }
            if (isEmpty(selectedSchool?.treaschlcode_list)) {
                setValue(treasuryCodeFieldName, "N/A");
            }
        }
    }, [selectedSchool]);

    return (
        <>
            {/* <Controller
                control={control}
                name={schoolNameFieldName}
                render={({ field }) => (
                    <Box mb={6}>
                        {isNotEmpty(label) && (
                            <InputLabel shrink>
                                {label}
                                {t("common.colon")}
                                {required && (
                                    <Box component="span" className="danger">
                                        *
                                    </Box>
                                )}
                            </InputLabel>
                        )}
                        <Autocomplete
                            options={schoolNameList2}
                            onChange={(e, newValue) => {
                                if (isNotEmpty(newValue)) {
                                    field.onChange(newValue);
                                } else {
                                    field.onChange("");
                                }

                                setFilledCode("");
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    style={{ width: "80%" }}
                                />
                            )}
                            value={field.value}
                            {...rest}
                        />
                    </Box>
                )}
            /> */}

            <CustomSchoolAutocomplete
                control={control}
                schoolNameFieldName={schoolNameFieldName}
                label={label}
                options={schoolNameList2.length > 0 ? schoolNameList2 : []}
                hanldFilledCode={() => {
                    setFilledCode("");
                }}
                displayFullOption={displayFullOption}
            />

            {isNotEmpty(SCRNFieldName) &&
                isNotEmpty(schoolName) &&
                !notShowSCRN && (
                    <Box mb={6}>
                        <CustomTextField
                            label={schoolCode}
                            value={SCRN}
                            inputProps={{
                                "aria-label": schoolCode,
                            }}
                        />
                    </Box>
                )}
            {isNotEmpty(treasuryCodeFieldName) && isNotEmpty(schoolName) && (
                <Box mb={6}>
                    <Controller
                        control={control}
                        name={treasuryCodeFieldName}
                        render={({ field }) => (
                            <>
                                {selectedSchool?.treaschlcode_list?.length >
                                    1 && (
                                    <CustomSelect
                                        control={control}
                                        label={t("common.schoolCode")}
                                        name={treasuryCodeFieldName}
                                        options={
                                            selectedSchool?.treaschlcode_list
                                        }
                                        needValue={true}
                                    />
                                )}
                                {selectedSchool?.treaschlcode_list?.length ===
                                    1 &&
                                    (disableDSSCode &&
                                    selectedSchool?.schlfinance_typecd ===
                                        "7" ? (
                                        <CustomTextField
                                            id={field.value}
                                            inputProps={{
                                                maxLength: 4,
                                            }}
                                            label={t("common.schoolCode")}
                                            onChange={(event) => {
                                                const value =
                                                    event.target.value.toUpperCase();
                                                field.onChange(value);
                                                onChange(value);
                                            }}
                                            value={field.value}
                                        />
                                    ) : (
                                        <CustomTextField
                                            id={field.value}
                                            label={t("common.schoolCode")}
                                            value={field.value}
                                        />
                                    ))}
                                {isEmpty(selectedSchool?.treaschlcode_list) && (
                                    <CustomTextField
                                        label={t("common.schoolCode")}
                                        value={"N/A"}
                                    />
                                )}
                            </>
                        )}
                    />
                </Box>
            )}
            {/* <CustomSelect
           options={schoolListOptions}
           control={control}
           name={schoolNameFieldName}
           {...rest}
        /> */}
        </>
    );
}
